// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Tracu","content":"styles_content__1XpUT","img":"styles_img__13i+8"};